// Ajax Setup
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

/**
 * Sweetalert handler
 * @param {success, error, warning, info} icon
 * @param {shorttext} title
 * @param {longtext} text
 * @param {dismissable button : boolean} button
 */
function sweetalert(icon, title, text = '', button = true) {
    var options = {
        icon: icon,
        title: title,
        text: text,
        showConfirmButton: button,
    };
    if (button == false)
        options.timer = 1500;
    Swal.fire(options);
}

window.sweetalert = sweetalert;

/**
 * Email Validation
 * @param {string} email
 */
function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

window.isEmail = isEmail;

/**
 * Action handler to submit with AJAX
 * @param {Ajax URL} url
 * @param {Data} data
 * @param {Table alias} targetTable
 * @param {ID modal} modalsource
 */
function ajaxSubmit(url, data, targetTable = '', modalsource = '', table2 = '') {
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (result) {
            if (result == 'success') {
                sweetalert('success', "Success", "", false);
                if (targetTable !== '')
                    targetTable.ajax.reload(null, false);
                if (modalsource !== '')
                    $("#" + modalsource).modal("hide");
                if (table2 !== '')
                    table2.ajax.reload(null, false);
            } else
                sweetalert('error', result);
        }
    });
}

window.ajaxSubmit = ajaxSubmit;


/**
 * Action handler to delete with AJAX
 * @param {Ajax URL} url
 * @param {table alias} table
 */
function ajaxDelete(url, table = '', table2 = '') {
    Swal.fire({
        title: "Are you sure to delete this?",
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: 'DELETE',
                url: url,
                success: function (msg) {
                    if (msg == 'success') {
                        sweetalert('success', msg);
                        if (table !== '')
                            table.ajax.reload(null, false);
                        if (table2 !== '')
                            table2.ajax.reload(null, false);
                    } else
                        sweetalert('error', msg);
                }
            });
        }
    });
}

window.ajaxDelete = ajaxDelete;

/**
 * Select2  Ajax
 */
function getSelect2(url, data, element, text, selectedId = '') {
    $.ajax({
        type: 'GET',
        url: url,
        data: data,
        dataType: 'json',
        success: function (res) {
            var val = '';
            if (text == 'All')
                val = 'all';

            var options = '<option value="' + val + '">' + text + '</option>';
            $.each(res, function (i) {
                options += '<option value="' + res[i].id + '">' + res[i].label + '</option>';
            });
            $(element).empty().append(options);
            var value = $(element).data("value");
            if (value !== undefined)
                $(element).val(value).trigger("change");

            if (selectedId !== '')
                $(element).val(selectedId).trigger("change");
        }
    });
}

window.getSelect2 = getSelect2;
